import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { DateStyles } from '../../constants/CentricConstants';

import { ModuleDialogs } from '../../constants/Dialogs';

import { TableRow, TableRowColumn } from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import DoneIcon from 'material-ui/svg-icons/action/done';
import DoneAllIcon from 'material-ui/svg-icons/action/done-all';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import CancelledIcon from 'material-ui/svg-icons/content/clear';
import WaitingIcon from 'material-ui/svg-icons/action/schedule';
import DialogActions from '../../actions/DialogActionCreator';
import SpotIcon from 'material-ui/svg-icons/image/lens';

import { getNextStatuses } from '../../stores/ModuleStore';
import { statusColours } from '../../constants/ColourConstants';
import { asDate } from '../../utils/Date';
import { formatName } from '../../utils/StringUtils';

class ModuleEnrolmentTableRow extends Component {

    constructor() {
        super(...arguments);
        this.state = {
            statuses: getNextStatuses(this.props.row.status) || []
        };
    }

    componentDidMount() {
        this.onEdit = this.onEdit.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.row.status !== this.props.row.status) {
            const statuses = (getNextStatuses(nextProps.row.status) || []);
            this.setState({statuses});
        }
    }

    onEdit() {
        DialogActions.open(ModuleDialogs.ENROLMENT_EDIT, {
            ...this.props.row,
            ...this.state,
            dateCompleted: !!this.props.row.dateCompleted ? new Date(this.props.row.dateCompleted) : null,
            currentEvent: this.props.row.eventId
        });
    }

    onDelete() {
        DialogActions.open(ModuleDialogs.ENROLMENT_DELETE, Object.assign({}, this.props.row, this.state));
    }

    getActions(isEditable) {
        let actions = [
            <IconButton key="delete" onClick={this.onDelete} disabled={this.props.row.loading}>
                <DeleteIcon color={statusColours.medium} />
            </IconButton>
        ];
        if (isEditable) {
            actions.unshift(
                <IconButton key="edit" onClick={this.onEdit} disabled={this.props.row.loading}>
                    <EditIcon color={statusColours.medium} />
                </IconButton>
            );
        }
        return actions;
    }

    getDataCell(row) {
        const deleted = !!Number(row.userDeleted);
        return (
            <TableRowColumn>
                {(!deleted && !row.userArchived)
                    ? <Link to={`/dashboard/user/${row.userId}`}>{formatName(row)}</Link>
                    : <span style={{color: statusColours.deleted}} title={`${deleted ? 'Deleted' : 'Archived'} user`}>{formatName(row)}</span>
                }
            </TableRowColumn>
        );
    }

    getEventCell(row) {
        return null;
    }

    render() {

        const { row, children, actions, ...others } = this.props;
        const infoLink = `/dashboard/module/${row.moduleId}/user/${row.userId}/enrolment`;

        let iconGroup = [];

        if (row.isAssigned) {
            if (row.isMandatory) {
                iconGroup.push(<SpotIcon className="icon-small-td" color={statusColours.mandatory} key="mandatory"/>);
            } else {
                iconGroup.push(<SpotIcon className="icon-small-td" color={statusColours.optional} key="optional"/>);
            }
        }

        let dateEnrolled = !!row.dateAdded ? new Date(row.dateAdded) : null;
        dateEnrolled = (!!dateEnrolled && !isNaN(dateEnrolled.valueOf())) ? dateEnrolled.toLocaleString('en-GB', DateStyles.short) : null;

        let dateCompleted = '';
        let status = '';
        const active = (!Number(row.userDeleted) && !row.userArchived);

        switch(row.status) {
            case 'cancelled':
                status = <CancelledIcon color={active ? statusColours.medium : statusColours.deleted}/>;
                break;
            case 'waiting':
                status = <WaitingIcon color={active ? statusColours.medium : statusColours.deleted}/>;
                break;
            case 'completed':
                if (!!row.dateCompleted) {
                    const date = asDate(row.dateCompleted);
                    if (!!date) {
                        dateCompleted = date.toLocaleString('en-GB', DateStyles.short);
                    }
                }
                status = (row.success === 'passed'
                    ? <DoneAllIcon color={active ? statusColours.primary : statusColours.deleted}/>
                    : <DoneIcon color={active ? statusColours.primary : statusColours.deleted}/>);
                break;

            default:
                break;

        }

        return (
            <TableRow {...others} selectable={active} >
                { children && children[0] }
                <TableRowColumn><Link to={infoLink}>{dateEnrolled} {iconGroup}</Link></TableRowColumn>
                {this.getDataCell(row)}
                <TableRowColumn><Link to={infoLink}>{dateCompleted}</Link></TableRowColumn>
                <TableRowColumn className="tbl-td-number"><Link to={infoLink}>{row.score}</Link></TableRowColumn>
                <TableRowColumn>{status}</TableRowColumn>
                {this.getEventCell(row)}
                <TableRowColumn className="tbl-td-actions">{actions || this.getActions(active)}</TableRowColumn>
            </TableRow>
        );
    }

}

ModuleEnrolmentTableRow.propTypes = {
    row:        PropTypes.shape({
        firstName:      PropTypes.string,
        lastName:       PropTypes.string,
        isMandatory:    PropTypes.bool,
        status:         PropTypes.string,
        success:        PropTypes.string,
        score:          PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        dateStart:      PropTypes.string,
        moduleType:     PropTypes.string
    }),

    rowProps:   PropTypes.object
};

ModuleEnrolmentTableRow.contextTypes = {
    auth:       PropTypes.object
};

export default ModuleEnrolmentTableRow;

export class ClassroomModuleEnrolmentTableRow extends ModuleEnrolmentTableRow {
    getEventCell(row) {
        if (!row.moduleType || row.moduleType !== 'classroom') { return null; }
        if (!row.eventStart) { return (<TableRowColumn/>); }

        const start = new Date(row.eventStart);
        const eventLink = `/dashboard/module/${row.moduleId}/event/${row.eventId}/attendance`;

        // if date exists, use that, otherwise empty
        return (
            <TableRowColumn>
                <Link to={eventLink}>
                    {start.toLocaleString('en-GB', DateStyles.short)}
                </Link>
            </TableRowColumn>
        );
    }
}

export class UserModuleEnrolmentTableRow extends ModuleEnrolmentTableRow {
    getDataCell(row) {
        return (
            <TableRowColumn>
                <Link to={`/dashboard/module/${row.moduleId}`} title={row.module}>
                    {row.module}
                </Link>
            </TableRowColumn>
        );
    }

    getEventCell(row) {
        if (!row.eventStart) { return (<TableRowColumn/>); }

        const start = new Date(row.eventStart);
        return (
            <TableRowColumn>
                <Link to={`/dashboard/module/${row.moduleId}/event/${row.eventId}/attendance`}>
                    {start.toLocaleString('en-GB', DateStyles.short)}
                </Link>
            </TableRowColumn>
        );
    }
}
